<template>
  <div>
    <el-divider content-position="left">审批流程</el-divider>
    <div v-if="processInstanceIdInfo.nodes && processInstanceIdInfo.nodes.length > 0" style="margin-top: 20px">
      <el-timeline :hide-timestamp="true">
        <el-timeline-item v-for="(node, index) in processInstanceIdInfo.nodes" :key="index">
          <div>
            {{ node.title }}&emsp;
            <el-tag
              v-if="node.userType != 1"
              :type="['info', 'primary', 'success', 'danger', 'danger'][node.status] || 'info'"
            >
              {{
                node.userType == 2 || node.userType == 4
                  ? nodeStatus[node.status]
                    ? nodeStatus[node.status]
                    : ''
                  : ccStatus[node.status]
                  ? ccStatus[node.status]
                  : ''
              }}
            </el-tag>
            <el-tag
              v-if="node.userType == 1 && node.status == 4"
              :type="['info', 'primary', 'success', 'danger', 'danger'][node.status] || 'info'"
            >
              {{ nodeStatus[node.status] ? nodeStatus[node.status] : '' }}
            </el-tag>
          </div>
          <div v-if="node.userType == 2 || node.userType == 4">
            <div v-for="(user, index) in node.users" :key="index">
              <div class="row-font">
                {{ user.nickname }}&emsp;
                <span v-if="node.status != 0">
                  {{ userStatus[user.status] ? userStatus[user.status] : '' }}
                </span>
              </div>
              <div class="row-font" v-if="node.status != 0 && user.status > 1">
                审批时间：{{ user.datetime }}
              </div>
              <div class="row-font" v-if="node.status != 0 && user.status > 1">
                审批备注：{{ user.comments || '-' }}
              </div>
            </div>
          </div>
          <div v-else>
            <div class="row-font">
              {{ getNicknames(node.users) }}
            </div>
            <div
              class="row-font"
              v-if="node.status != 0 && node.status != 1 && node.users.length > 0"
            >
              {{ userType[node.userType] }}时间：{{ node.users[0].datetime }}
            </div>
          </div>
        </el-timeline-item>
        <!-- 系统异常 -->
        <el-timeline-item v-if="processInstanceIdInfo && processInstanceIdInfo.status == 10">
          <div class="">
            <el-tag type="danger">系统异常</el-tag>
            &emsp;{{ processInstanceIdInfo.error || '-' }}
          </div>
        </el-timeline-item>
      </el-timeline>
    </div>
    <div>
      <el-button type="text" @click="$emit('addRemark')"> 添加备注 </el-button>
      <div style="width: 60%">
        <div class="remark" v-for="item in remarks" :key="item.id">
          <div class="title">
            <span style="font-weight: 600">{{ item.createBy }}</span>
            <span style="color: #cdcdcd">{{ item.createTime }}</span>
          </div>
          <div class="content">
            <div style="margin-bottom: 5px">{{ item.remark }}</div>
            <span
              style="color: #00daff; margin-right: 5px"
              v-for="user in item.noticer || []"
              :key="user"
            >
              @{{ user }}
            </span>
            <div style="margin-top: 5px" v-if="item.imgUrls && item.imgUrls.length > 0">
              <ImageList :attachmentUrl="item.imgUrls.join(',')" />
            </div>
            <div style="margin-top: 5px" v-if="item.pdfs && item.pdfs.length > 0">
              <el-image
                class="img"
                v-for="url in item.pdfs"
                :key="url"
                :src="require(`@/assets/image/pdf.png`)"
                fit="scale-down"
                @click="$emit('openPdf', url)"
              ></el-image>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AuditProcess',
  props: {
    processInstanceIdInfo: {
      type: Object,
      default: () => ({})
    },
    remarks: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      // 0-待审批；1-审批中；2-已通过；3-未通过;4-已撤销;5-已退回
      nodeStatus: ['待审批', '审批中', '已通过', '未通过', '已撤销', '已退回'],
      ccStatus: ['待抄送', '', '已抄送', '', ''],
      // 1-处理中；2-已撤销；3-已驳回；4-已结束；5-已退回；6-已挂起；10-系统异常
      userStatus: [
        '',
        '处理中',
        '已撤销',
        '已驳回',
        '已通过',
        '已退回',
        '已挂起',
        '系统异常'
      ],
      userType: ['', '申请', '审批', '抄送']
    }
  },
  methods: {
    getNicknames(arr) {
      return (arr || []).map(a => a.nickname).join('、')
    }
  }
}
</script>

<style scoped>
.row-font {
  font-size: 14px;
  color: #606266;
  margin-bottom: 5px;
}

.remark {
  width: 100%;
}

.remark .title {
  display: flex;
  justify-content: space-between;
  padding: 5px 10px;
}

.remark .content {
  padding: 5px;
  margin: auto 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
}

.remark .content .img {
  width: 100px;
  height: 100px;
  padding: 2px 5px 2px 0;
  cursor: pointer;
}
</style>
